import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './Core_Audit_Log.css';

const Core_Audit_Log = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"CORE_AUDIT_LOG",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	CORE_AUDIT_LOG:-1
  });


  const [CORE_AUDIT_LOG, setCORE_AUDIT_LOG] = React.useState(null);
  const [CORE_AUDIT_LOG_D, setCORE_AUDIT_LOG_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Core Audit Log');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/Core_Audit_Log',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewCORE_AUDIT_LOG(clientInfo,"OpenNew");

		navigate('/Core_Audit_Log',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Audit_Log_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutCORE_AUDIT_LOG(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostCORE_AUDIT_LOG(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewCORE_AUDIT_LOG(clientInfo,"OpenNew");
		}
		navigate('/Core_Audit_Log',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Audit_Log_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Audit_Log_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Audit_Log_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
		if(Temp_Data2.status!="New"){
			handleDeleteCORE_AUDIT_LOG(Temp_Data2);
			navigate('/Core_Audit_Log#New',{replace:true});
		} 
		else 
			navigate('/Core_Audit_Log',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Audit_Log',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Audit_Log',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Audit_Log',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/Core_Audit_Log',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!CORE_AUDIT_LOG) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [CORE_AUDIT_LOG]) ;


  
  
  var Ids = [];
  for(var Ele in CORE_AUDIT_LOG){
	  for(var Sec in CORE_AUDIT_LOG[Ele]){
		if(Sec == "id")
			Ids.push(CORE_AUDIT_LOG[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(CORE_AUDIT_LOG[Ele]["status"]);
		else if(Array.isArray(CORE_AUDIT_LOG[Ele][Sec]))
			  for(var Row in CORE_AUDIT_LOG[Ele][Sec])  // Convert to CORE_AUDIT_LOG[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in CORE_AUDIT_LOG[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["CORE_AUDIT_LOG"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewCORE_AUDIT_LOG(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_AUDIT_LOG`).then((response1) => {
		if(!CORE_AUDIT_LOG) 
			setCORE_AUDIT_LOG(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_AUDIT_LOG_D`).then((response2) => {
			setCORE_AUDIT_LOG_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddCORE_AUDIT_LOG_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewCORE_AUDIT_LOG = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_AUDIT_LOG/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setCORE_AUDIT_LOG(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataCORE_AUDIT_LOG = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_AUDIT_LOG/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutCORE_AUDIT_LOG = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_AUDIT_LOG/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostCORE_AUDIT_LOG = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_AUDIT_LOG', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteCORE_AUDIT_LOG = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/CORE_AUDIT_LOG', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_0"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_0",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_1"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_1",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  

const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_2"]=value;
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_2",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
  }; 
  

    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_3"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_3",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["1"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_4"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("1","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_4",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["2"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_0"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("2","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_0",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["2"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_1"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("2","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_1",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["3"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_0"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("3","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_0",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["3"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_1"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("3","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_1",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["4"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_4_0"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("4","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_4_0",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  

const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_0",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
  }; 
  

    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_1"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_1",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_2"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_2",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_3"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_3",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
	Temp_Data["9"]["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_4"]=value;
	//handleAddCORE_AUDIT_LOG(Temp_Data,App_Data['CORE_AUDIT_LOG']);
	Form_Data_onChange("9","PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_4",value,Temp_Data);
 	//handleLastDataCORE_AUDIT_LOG(Temp_Data);
    setCORE_AUDIT_LOG(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!CORE_AUDIT_LOG) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedCORE_AUDIT_LOG =JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
  updatedCORE_AUDIT_LOG[Sec] = [...updatedCORE_AUDIT_LOG[Sec], newRow];
  setCORE_AUDIT_LOG(updatedCORE_AUDIT_LOG);
};

const handleDeleteRow = (sec,index) => {
  const updatedCORE_AUDIT_LOG = JSON.parse(JSON.stringify(CORE_AUDIT_LOG));
  updatedCORE_AUDIT_LOG[sec].splice(index, 1);
  setCORE_AUDIT_LOG(updatedCORE_AUDIT_LOG);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Core Audit Log`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Audit Log ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Audit Log ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_0" type="text" className="form-control" placeholder="Audit Log ID" value={CORE_AUDIT_LOG["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_0`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Audit Log ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`User ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_1" type="text" className="form-control" placeholder="User ID" value={CORE_AUDIT_LOG["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter User ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Action Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_2"  value={CORE_AUDIT_LOG["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_2`]} onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_2_Change} className="form-control" name="Action Type"  >
						  <option value="Create">Create</option>
						  <option value="Read">Read</option>
						  <option value="Update">Update</option>
						  <option value="Delete">Delete</option>
						  <option value="Submit">Submit</option>
						  <option value="Approve">Approve</option>
						  <option value="Reject">Reject</option>
						  <option value="Login">Login</option>
						  <option value="Logout">Logout</option>
						  <option value="Export">Export</option>
						  <option value="Import">Import</option>
						  <option value="Freeze">Freeze</option>
						  <option value="Unfreeze">Unfreeze</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Action Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Entity Type`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_3" type="text" className="form-control" placeholder="Entity Type" value={CORE_AUDIT_LOG["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_3`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter Entity Type`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Entity ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_4" type="text" className="form-control" placeholder="Entity ID" value={CORE_AUDIT_LOG["1"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_4`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_1_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Entity ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Old Value JSON`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '5000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Old Value JSON`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_0" type="text" className="form-control" placeholder="Old Value JSON" value={CORE_AUDIT_LOG["2"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_0`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '5000ch' }}>
						 {t(`Enter Old Value JSON`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '5000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`New Value JSON`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_1" type="text" className="form-control" placeholder="New Value JSON" value={CORE_AUDIT_LOG["2"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '5000ch' }}>
						 {t(`Enter New Value JSON`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`IP Address`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`IPAddress`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_0" type="text" className="form-control" placeholder="IPAddress" value={CORE_AUDIT_LOG["3"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_0`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter IPAddress`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`User Agent`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_1" type="text" className="form-control" placeholder="User Agent" value={CORE_AUDIT_LOG["3"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter User Agent`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Immutable Hash`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '128ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Immutable Hash`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_4_0" type="text" className="form-control" placeholder="Immutable Hash" value={CORE_AUDIT_LOG["4"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_4_0`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '128ch' }}>
						 {t(`Enter Immutable Hash`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_0"  value={CORE_AUDIT_LOG["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_0`]} onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_1" type="text" className="form-control" placeholder="Created By" value={CORE_AUDIT_LOG["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_1`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_2" type="text" className="form-control" placeholder="Created At" value={CORE_AUDIT_LOG["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_2`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_3" type="text" className="form-control" placeholder="Updated By" value={CORE_AUDIT_LOG["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_3`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_4" type="text" className="form-control" placeholder="Updated At" value={CORE_AUDIT_LOG["9"][`PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_4`]} 
						onChange={PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_06_CORE_OPERATIONS_AUDIT_REPORTING_CORE_AUDIT_LOG_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default Core_Audit_Log;  